import CityPageTemplate from "../city-template/CityPageTemplate";
import { rochesterConfig } from "./data";

export default function RochesterNHPage() {
  return <CityPageTemplate config={rochesterConfig} />;
}